import { Input } from "@/shadcn/components/ui/input";
import React from "react";

type TimePickerProps = {
  selected: Date | null;
  onChange: (time: Date | null) => void;
};

const TimePicker: React.FC<TimePickerProps> = ({ selected, onChange }) => {
  const hours = selected ? selected.getHours() : 0;
  const minutes = selected ? selected.getMinutes() : 0;
  const seconds = selected ? selected.getSeconds() : 0;

  const handleHoursChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newHours = !isNaN(parseInt(e.target.value, 10))
      ? parseInt(e.target.value, 10)
      : 0;
    if (selected) {
      const newTime = new Date(selected);
      newTime.setHours(newHours);
      onChange(newTime);
    } else {
      const newTime = new Date();
      newTime.setHours(newHours);
      newTime.setMinutes(0);
      newTime.setSeconds(0);
      onChange(newTime);
    }
  };

  const handleMinutesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newMinutes = !isNaN(parseInt(e.target.value, 10))
      ? parseInt(e.target.value, 10)
      : 0;
    if (selected) {
      const newTime = new Date(selected);
      newTime.setMinutes(newMinutes);
      onChange(newTime);
    } else {
      const newTime = new Date();
      newTime.setHours(0);
      newTime.setMinutes(newMinutes);
      newTime.setSeconds(0);
      onChange(newTime);
    }
  };

  const handleSecondsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newSeconds = !isNaN(parseInt(e.target.value, 10))
      ? parseInt(e.target.value, 10)
      : 0;
    if (selected) {
      const newTime = new Date(selected);
      newTime.setSeconds(newSeconds);
      onChange(newTime);
    } else {
      const newTime = new Date();
      newTime.setHours(0);
      newTime.setMinutes(0);
      newTime.setSeconds(newSeconds);
      onChange(newTime);
    }
  };

  return (
    <div className="flex space-x-2 justify-center">
      <Input
        type="number"
        value={hours}
        onChange={handleHoursChange}
        className="w-12 p-1 border rounded"
        min="0"
        max="23"
      />
      <span className="content-center">:</span>
      <Input
        type="number"
        value={minutes}
        onChange={handleMinutesChange}
        className="w-12 p-1 border rounded"
        min="0"
        max="59"
      />
      <span className="content-center">:</span>
      <Input
        type="number"
        value={seconds}
        onChange={handleSecondsChange}
        className="w-12 p-1 border rounded"
        min="0"
        max="59"
      />
    </div>
  );
};

export default TimePicker;
